import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complianceService } from '../../services/complianceService';

export const useGetAmlNotifications = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.compliance.notifications],
    queryFn: () =>
      complianceService.notifications().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
